import Fuse from 'fuse.js';
import { useEffect, useState } from 'react';

/**
 * @param {import('../types/feature').Feature[]} features
 * @param {string} categoryFilterTerm
 * @param {string} searchValue
 * @returns {[import('../types/feature').Feature[], import('../types/feature').Feature[]]}
 */
export const useFeatures = (features, categoryFilterTerm, searchValue) => {
	const [primaryFeatures, setPrimaryFeatures] = useState(/** @type {import('../types/feature').Feature[]} */ ([]));
	const [secondaryFeatures, setSecondaryFeatures] = useState(/** @type {import('../types/feature').Feature[]} */ ([]));

	useEffect(() => {
		setPrimaryFeatures(() => {
			if (searchValue !== '') {
				return filterFeaturesBySearchTerm(features, searchValue);
			}

			if (categoryFilterTerm === 'all') {
				return features;
			} else if (categoryFilterTerm === 'staff_pick') {
				return features.filter((feature) => feature.staff_pick);
			} else {
				return features.filter((feature) => {
					return feature.primary_category === categoryFilterTerm;
				});
			}
		});

		setSecondaryFeatures(() => {
			const defaultFilterTerms = ['all', 'staff_pick'];
			if (searchValue === '' && !defaultFilterTerms.includes(categoryFilterTerm)) {
				return features.filter((feature) => feature.secondary_categories?.includes(categoryFilterTerm));
			}

			return [];
		});
	}, [categoryFilterTerm, searchValue]);

	return [primaryFeatures, secondaryFeatures];
};

/**
 * @param {import('../types/feature').Feature[]} features
 * @param {string} term
 */
const filterFeaturesBySearchTerm = (features, term) => {
	const fuse = new Fuse(features, {
		threshold: 0.3,
		keys: ['name', 'desc_grid', 'desc_list', 'detail_func'],
	});
	return fuse.search(term).map((result) => result.item);
};
